import React, { useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import {
    Divider,
    Grid,
    IconButton,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Edit } from '@material-ui/icons';
import Cookies from 'universal-cookie';
import TankView from '../Components/TankView.js';
import TlmBreadcrumbs from '../Components/TlmBreadcrumbs.jsx';
import { host } from "../../data";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    content: {
        padding: theme.spacing(2),
    },
    iconButtons: {
        marginRight: theme.spacing(1),
    },
    text: {
        marginLeft: theme.spacing(10),
    },
}));

export default function TankPage({ orgInfo, branchInfo, sitesNavDict }) {
    const { t } = useTranslation();
    const classes = useStyles();
    // Get params so we can read the url path parameters
    const params = useParams();
    let Data = {};
    // Get the site and tank names and site ID.
    const site = params.siteName;
    const siteId = sitesNavDict[site][0];
    const isEditor = sitesNavDict[site][1];
    const tank = params.tankName;
    //const tankId = 0;
    const [tankId, setTankId] = useState(0);
    // Todo: TankPage - Get the tankId to pass to the TabSettings component.
    const [tankData, setTankData] = React.useState({ latestReading: '11-12-2020', GpsReadings: []});
    const [tankDataReady, setTankDataReady] = React.useState(0);
    const [defTimePeriod, setDefTimePeriod] = React.useState('90');

    React.useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(data => {
                if (null !== tank) {
                    var body = JSON.stringify({ 'name': tank });

                    var requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                        body: body
                    };

                    fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/lookup', requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            setTankId(data.tankId);
                        }).catch((error) => {
                        });
                }
            });
    }, [tank]);

    const yyyymmdd = (d) => {
        var date = new Date(d);
        date.toISOString().slice(0, 10).replace(/-/g, "");
        return date.toISOString().slice(0, 10).replace(/-/g, "");
      };

    React.useEffect(() => {
        var cookies = new Cookies();
        var tFilter = cookies.get('tankFilter');
        var timePeriod = '90';
        var d1 = 1609480800000;
        var d2 = 1640844000000;

        if (undefined !== tFilter) {
            timePeriod = tFilter;
            setDefTimePeriod(timePeriod);
        }
        if (orgInfo.orgName === "Graco Demo"){
            timePeriod = "Custom";
        }

        Auth.currentAuthenticatedUser()
            .then(data => {
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    }
                };

                if (tankId) {
                    console.log("Fetching tank info...")
                    let url = host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId + '/history?type=' + timePeriod;
                    if (orgInfo.orgName === "Graco Demo"){
                        url = host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId + '/history?type=' + timePeriod + '&range=' + yyyymmdd(d1) + '-' + yyyymmdd(d2);
                    }
                    fetch(url, requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            console.log("Tank info fetched.")
                            Data = data.TankData;
                            // data format: {"TankData": Tank History, "LatestMeasurement": Latest Measurement, "TankInfo": Tank Definition}
                            setTankData(data);
                            setTankDataReady(1);
                        }).catch((error) => {
                        });
                }
            });
    }, [tankId]);

    return (
        <Grid container
            direction='column'
            justify='flex-start'
            alignItems='stretch'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    <TlmBreadcrumbs edge='start'
                        orgInfo={orgInfo}
                        branchInfo={branchInfo}
                        site={site}
                        tank={tank} />
                    {isEditor
                        ? <Tooltip title={t("editTank")}>
                            <IconButton color='inherit'
                                component={RouterLink}
                                to={'/orgs/' + orgInfo.orgName + '/branches/' + branchInfo.branchName + '/sites/' + site + '/tanks/' + tank + '/edit'}
                                className={classes.iconButtons}>
                                <Edit />
                            </IconButton>
                        </Tooltip>
                        : null}
                    <div className={classes.grow} />
                </Toolbar>
                <Divider />
            </Grid>

            {tankDataReady ? <Grid item xs>
                {(true || (tankData.TankInfo !== undefined)) && <TankView isEditor={isEditor} tank={tankData} siteName={site}
                    orgInfo={orgInfo} branchInfo={branchInfo}
                    site={site} siteId={siteId} tankId={tankId}
                    defTimePeriod={defTimePeriod} />}
                {(tankData.TankInfo === undefined) && <Typography>{t("noTankInformationAvailable")}</Typography>}
            </Grid>
                : <Grid item xs>
                    <Typography align="center">{t("loadingTankData")}</Typography>
                </Grid>}
        </Grid>
    )
}